// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__3Fdst","title":"styles_title__3jn62","description":"styles_description__3fSsa","saveButton":"styles_saveButton__17smm"};